import { Alert, Box } from '@mui/material';
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from '@stripe/react-stripe-js';
import { Stripe } from '@stripe/stripe-js';
import { useContext } from 'react';
import SnackbarContext from '../../../../../contexts/SnackbarContext';
import { PaymentState } from '../../../../../generated-types/paymentState';
import DarkPalette from '../../../../../theme/DarkPalette';

/**
 * The properties for the checkout session component
 */
interface CheckoutSessionProps {
  /**
   * The stripe promise for the embedded checkout
   */
  stripePromise: Stripe;
  /**
   * The secret that will initialize the embedded checkout details
   */
  clientSecret: string;
  /**
   * A state variable function to control the payment state
   * @param _ The payment state to set
   */
  setPaymentState: (_: PaymentState) => void;
}

/**
 * The checkout session component
 */
const CheckoutSession = (props: CheckoutSessionProps) => {
  const snackbar = useContext(SnackbarContext);

  return (
    <Box
      id="checkout"
      marginTop="1em"
      paddingTop="1em"
      paddingBottom="1em"
      borderRadius="1em"
      sx={{
        backgroundColor: DarkPalette.background?.paper,
      }}
    >
      <EmbeddedCheckoutProvider
        stripe={props.stripePromise}
        options={{
          clientSecret: props.clientSecret,
          // The following callback can be used to handle session completion
          onComplete: () => {
            props.setPaymentState(PaymentState.WaitingPayment);
            snackbar.setAlert(
              <Alert severity="success" variant="filled">
                Successfully submitted payment!
              </Alert>
            );
            snackbar.triggerSnackbar();
          },
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </Box>
  );
};

export default CheckoutSession;
